import CXMApiClient from "../CXMApiClient";

function initialLoad() {
  return {
    ManageWishlistVehicleModalInfo: {
      showModal: false,
      data: null
    },
    ManageWishlistGroupsModalInfo: {
      showModal: false,
      data: null
    },
    ManageLeadWishlistModalInfo: {
      showModal: false,
      data: null
    }
  };
}

const state = initialLoad();

const actions = {
  async getWishlistGroups(context, platformId) {
    let cxmApiClient = new CXMApiClient();
    let response = await cxmApiClient.ProcessRequest(
      "GET",
      `/api/wishlist/wishlist_groups/platform/${platformId}`
    ).catch(ex => ex.response);
    return response && response.data ? response.data : null;
  },
  async saveWishlistGroup(context, payload) {
    let cxmApiClient = new CXMApiClient();
    let response = await cxmApiClient
      .ProcessRequest("POST", `/api/wishlist/wishlist_group`, payload)
      .catch(ex => ex.response);
    return response && response.data ? response.data : null;
  },
  async deleteWishlistGroup(context, wishlistGroupId) {
    let cxmApiClient = new CXMApiClient();
    let response = await cxmApiClient
      .ProcessRequest(
        "DELETE",
        `/api/wishlist/wishlist_group/${wishlistGroupId}`
      )
      .catch(ex => ex.response);
    return response && response.data ? response.data : null;
  },
  async getWishlistSearchResults(context, request) {
    let cxmApiClient = new CXMApiClient();
    let response = await cxmApiClient.ProcessRequest(
      "POST",
      `/api/wishlist/wishlist_vehicle/search`,
      request
    ).catch(ex => ex.response);
    return response && response.data ? response.data : null;
  },
  async saveWishlistVehicle(context, payload) {
    let cxmApiClient = new CXMApiClient();
    let response = await cxmApiClient
      .ProcessRequest("POST", `/api/wishlist/wishlist_vehicle`, payload)
      .catch(ex => ex.response);
    return response && response.data ? response.data : null;
  },
  updateManageWishlistVehicleModal(context, data) {
    context.commit("updateManageWishlistVehicleModal", data);
  },
  updateManageWishlistGroupsModal(context, data) {
    context.commit("updateManageWishlistGroupsModal", data);
  },
  async getWishlistVehicleStock(context, request) {
    let cxmApiClient = new CXMApiClient();
    let response = await cxmApiClient
      .ProcessRequest(
        "POST",
        `/api/wishlist/wishlist_vehicle/inventory`,
        request
      )
      .catch(ex => ex.response);
    return response && response.data ? response.data : null;
  },
  async getWishlistVOIContacts(context, payload) {
    let cxmApiClient = new CXMApiClient();
    let response = await cxmApiClient
      .ProcessRequest(
        "POST",
        `/api/wishlist/wishlist_vehicle/voi/contacts`,
        payload
      )
      .catch(ex => ex.response);
    return response && response.data ? response.data : null;
  },
  async getWishlistLeadContacts(context, payload) {
    let cxmApiClient = new CXMApiClient();
    let response = await cxmApiClient
      .ProcessRequest(
        "POST",
        `/api/wishlist/wishlist_vehicle/lead/contacts`,
        payload
      )
      .catch(ex => ex.response);
    return response && response.data ? response.data : null;
  },
  async getWishlistWorkflows(context, request) {
    let cxmApiClient = new CXMApiClient();
    return await cxmApiClient
      .ProcessRequest(
        "POST",
        `/api/wishlist/wishlist_vehicle/workflow`,
        request
      )
      .catch(err => err.response);
  },
  updateLeadWishlistModal(context, data) {
    state.ManageLeadWishlistModalInfo = data;
  },
  async saveLeadVOIWishlist(context, payload) {
    let cxmApiClient = new CXMApiClient();
    let response = await cxmApiClient
      .ProcessRequest("POST", `/api/wishlist/wishlist_vehicle/lead`, payload)
      .catch(ex => ex.response);
    return response && response.data ? response.data : null;
  },
  async deleteLeadVOIWishlist(context, id) {
    let cxmApiClient = new CXMApiClient();
    let response = await cxmApiClient
      .ProcessRequest(
        "DELETE",
        `/api/wishlist/wishlist_vehicle/lead?wishlistVehicleLeadId=${id}`
      )
      .catch(ex => ex.response);
    return response && response.data ? response.data : null;
  }
};
const mutations = {
  updateManageWishlistVehicleModal(state, data) {
    state.ManageWishlistVehicleModalInfo = data;
  },
  updateManageWishlistGroupsModal(state, data) {
    state.ManageWishlistGroupsModalInfo = data;
  },
  updateLeadWishlistModal(state, data) {
    state.ManageLeadWishlistModalInfo = data;
  }
};

const getters = {};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/Wishlist.js